import styles from './styles.module.css'
import TechRouteCard from '../../../../../global/components/cards/technician/technician-route-card/TechRouteCard'
import TechAvatarCard from '../../../../../global/components/cards/technician/technician-avatar-card/TechAvatarCard'
import { ILocation } from '../../../../../../../app/entities/Location'
import { IRoute } from '../../../../../../../app/entities/Route'
import { IRouteInstruction } from '../../../../../../../app/entities/RouteInstruction'
import { STANDARD_TIME_SLOT_TYPES } from '../../../../../global/constants/time-slot'
import { TYPES } from '../../../../../global/constants/route-instructions'

interface TechTableRowProps {
  route: IRoute
  techAvatarUri: string | undefined
  date: string
  refetch: () => void
}

function renderRouteInstructionCards(
  routeInstructions: IRouteInstruction[],
  isDeliveryOnlyTechnician: boolean,
  location: ILocation,
): JSX.Element[] {
  const renderedRouteInstructions: JSX.Element[] = []
  const routeInstructionsHaveNoOrders =
    routeInstructions.length === 0 || routeInstructions.every((ri) => !ri.order)

  if (routeInstructionsHaveNoOrders) {
    return [
      <div
        key='no-orders'
        style={{ width: '100%', height: '100%' }}
      >
        <div className={styles.noOrdersContainer}> No Orders</div>
      </div>,
    ]
  }

  if (isDeliveryOnlyTechnician) {
    let deliveryRouteIndex = 1
    renderedRouteInstructions.push(
      <div
        key='route-header-1'
        className={styles.timePlaceholder}
      >
        <span
          className={styles.timePlaceholderText}
        >{`Route ${deliveryRouteIndex}`}</span>
      </div>,
    )

    const sortedRouteInstructions = routeInstructions.sort(
      (a, b) => a.index - b.index,
    )

    for (const routeInstruction of sortedRouteInstructions) {
      const { order, type, objectId } = routeInstruction

      switch (type) {
        case TYPES.TAKE_LUNCH:
          renderedRouteInstructions.push(
            <div
              key={`lunch-${objectId}`}
              className={styles.lunchTimePlaceholder}
            >
              <span className={styles.timePlaceholderText}>Lunch</span>
            </div>,
          )
          break
        case TYPES.REFILL_VEHICLE:
          deliveryRouteIndex += 1
          renderedRouteInstructions.push(
            <div
              key={`route-header-${deliveryRouteIndex}`}
              className={styles.timePlaceholder}
            >
              <span
                className={styles.timePlaceholderText}
              >{`Route ${deliveryRouteIndex}`}</span>
            </div>,
          )
          break
        default:
          if (!order) break
          renderedRouteInstructions.push(
            <TechRouteCard
              key={objectId}
              order={order}
              location={location}
              startTime={routeInstruction.startTimeGenerated}
              endTime={routeInstruction.endTimeGenerated}
            />,
          )
          break
      }
    }
  } else {
    for (const timeSlotType of STANDARD_TIME_SLOT_TYPES) {
      renderedRouteInstructions.push(
        <div
          key={`timeslot-${timeSlotType}`}
          className={styles.timePlaceholder}
        >
          <span className={styles.timePlaceholderText}>{timeSlotType}</span>
        </div>,
      )

      const routeInstructionsForTimeSlot = routeInstructions.filter(
        (ri) => ri.schedule === timeSlotType,
      )

      const sortedRouteInstructions = routeInstructionsForTimeSlot.sort(
        (a, b) => a.index - b.index,
      )
      for (const routeInstruction of sortedRouteInstructions) {
        const { order, type, objectId } = routeInstruction

        switch (type) {
          case TYPES.TAKE_LUNCH:
            renderedRouteInstructions.push(
              <div
                key={`lunch-${objectId}`}
                className={styles.lunchTimePlaceholder}
              >
                <span className={styles.timePlaceholderText}>Lunch</span>
              </div>,
            )
            break
          default:
            if (!order) break
            renderedRouteInstructions.push(
              <TechRouteCard
                key={objectId}
                order={order}
                location={location}
                startTime={routeInstruction.startTimeGenerated}
                endTime={routeInstruction.endTimeGenerated}
              />,
            )
            break
        }
      }
    }
  }

  return renderedRouteInstructions
}

export default function TechTableRow(props: TechTableRowProps) {
  const { date, route, techAvatarUri, refetch } = props
  const { location, routeInstructions, technician } = route

  const isRouteBlank = !technician || route.routeInstructions?.length === 0

  const isDeliveryOnlyTechnician =
    technician?.acceptsDeliveries && !technician?.acceptsInstallations

  return (
    <div className={`${styles.rowContainer} ${isRouteBlank && styles.blank}`}>
      <div className={styles.techInfo}>
        <TechAvatarCard
          date={date}
          techAvatarUri={techAvatarUri}
          route={route}
          triggerRerender={refetch}
          blank={isRouteBlank}
        />
      </div>
      <div className={styles.routesContainer}>
        {location &&
          renderRouteInstructionCards(
            routeInstructions,
            isDeliveryOnlyTechnician ?? false,
            location,
          )}
      </div>
    </div>
  )
}
